import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router'

//styles
import './Users.css'

// semantic ui react
import {
  Container,
  Header,
  Icon,
  Table,
  Loader
} from 'semantic-ui-react'

//graphql
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'

const GET_USERS = gql`
  query getUsers {
    me {
      id
      admin
      users {
        id
        email
        username
        name
        meta
        admin
      }
    }
  }
`

const Users = props => {
  // get users
  let { loading, error, called, data } = useQuery(GET_USERS)
  // states
  const [me, setMe] = useState()
  const [users, setUsers] = useState([])
  // set users after load
  useEffect(() => {
    if (data && !loading && !error) {
      setMe(data.me || null)
      setUsers(data.me.users || [])
    }
  }, [data])

  // go to create single user
  const history = useHistory()
  const goToCreateUser = e => {
    history.push('/users/create')
  }

  return (
    <Container className='Users'>
      <Header as='h3' floated='left'>
        <Icon name='user' />
        <Header.Content>
          Users
          <Header.Subheader>List of users:</Header.Subheader>
        </Header.Content>
      </Header>
      <Header as='a' floated='right' onClick={goToCreateUser} className='add-user'>
        <Icon name='plus square outline' />Create New User
      </Header>

      {loading && called && (<Loader active>Loading users...</Loader>)}

      {!loading && called && (
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>User Name</Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>E-mail</Table.HeaderCell>
              <Table.HeaderCell>Admin</Table.HeaderCell>
              <Table.HeaderCell>Updated Password</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {users && users.map(user => (
              <Table.Row key={user.id}>
                <Table.Cell><Link to={`/users/${user.id}`}>{user.username}</Link></Table.Cell>
                <Table.Cell>{user.name}</Table.Cell>
                <Table.Cell>{user.email}</Table.Cell>
                <Table.Cell textAlign='center' collapsing>
                  {user.admin ?
                    (<Icon name='check circle outline' color='green' />)
                    : (<Icon name='times circle outline' color='red' />)
                  }
                </Table.Cell>
                <Table.Cell textAlign='center' collapsing>
                  {(user.meta && user.meta.updated_password) ?
                    (<Icon name='check circle outline' color='green' />)
                    : (<Icon name='times circle outline' color='red' />)
                  }
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Container>
  )
}

export default Users
